import { render, staticRenderFns } from "./GroupsMembers.vue?vue&type=template&id=b0095c60&scoped=true&"
import script from "./GroupsMembers.vue?vue&type=script&lang=js&"
export * from "./GroupsMembers.vue?vue&type=script&lang=js&"
import style0 from "./GroupsMembers.vue?vue&type=style&index=0&id=b0095c60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0095c60",
  null
  
)

export default component.exports